export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

/**
 * Covers are left empty on purpose: the barre covers were removed. Add the
 * hosted cover URL of each Memory Care bonus to `cover` when the images exist.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Start Here: Your First Five Days',
    body: 'Your first week, already planned. Five days, ten activities from across the six volumes, and a simple path to find the right activity for any moment, so Monday starts without planning.',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'Print-and-Play Pack: Large-Print Cards and Boards for 9 Activities',
    body: 'Print it, and the game is ready. Large-print cards and boards for nine activities in the pack, designed for adults, readable from across the table and printable in black and white. Nothing to cut or laminate.',
    accent: 'bg-gold',
  },
  {
    number: '03',
    title: 'The Dignity Language Guide: 60 Swaps That Keep Every Activity Adult',
    body: 'The words that make an activity feel adult. Sixty swaps from what we often say to what respects the person in front of us, plus invitations that get a “yes” more often than “Do you want to join?”.',
    accent: 'bg-smoke',
  },
  {
    number: '04',
    title: 'When the Plan Changes: 20 Tricky Moments During an Activity',
    body: 'What to do when a group does not go to plan. Twenty moments every activity professional knows, each with what to try first, what to try next, and when to stop and tell the nurse.',
    accent: 'bg-coral',
  },
  {
    number: '05',
    title: 'The One-Page Explainers: Do · Help · Feel for Your Team and Families',
    body: 'Two one-page handouts that explain the method in 60 seconds, one for the care team and one for families, plus a poster for the activity room.',
    accent: 'bg-plum-mid',
  },
]
